import '@theme/theme-drawer';
const mobile = matchMedia('(max-width:749px)');
function sync(drawer, open) {
  document.querySelectorAll('[data-jl-open-navigation]').forEach(trigger => {
    if (trigger.getAttribute('aria-controls') === drawer.id) trigger.setAttribute('aria-expanded', String(open));
  });
}
document.addEventListener('click', event => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-jl-open-navigation]') : null;
  if (!trigger || !mobile.matches) return;
  const drawer = document.getElementById(trigger.getAttribute('aria-controls'));
  if (!drawer || typeof drawer.open !== 'function') return;
  event.preventDefault();
  document.querySelectorAll('theme-drawer[open]').forEach(other => { if (other !== drawer) other.close(); });
  drawer.open();
});
document.addEventListener('theme-drawer:open', event => {
  if (event.target.matches('.jl-mobile-navigation')) sync(event.target, true);
});
document.addEventListener('theme-drawer:close', event => {
  if (event.target.matches('.jl-mobile-navigation')) sync(event.target, false);
});
document.addEventListener('toggle', event => {
  const detail = event.target;
  if (!detail.matches?.('[data-jl-mobile-navigation]>details[open]')) return;
  [...detail.parentElement.children].forEach(other => { if (other !== detail && other.tagName === 'DETAILS') other.open = false; });
}, true);
document.addEventListener('click', event => {
  const link = event.target instanceof Element ? event.target.closest('.jl-mobile-navigation a[href]') : null;
  link?.closest('theme-drawer')?.close();
});
mobile.addEventListener('change', () => {
  if (!mobile.matches) document.querySelectorAll('.jl-mobile-navigation[open]').forEach(drawer => drawer.close());
});
